import { CoachAvatar } from '@features/coaches/coachCard/coachAvatar/ui.tsx';
import { enableScroll } from '@shared/helpers';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import { CommonButton } from '@shared/ui/index.ts';
import { ModalSmall } from 'library/components/common';
import { closeRecommendModal } from 'library/redux/modal';
import * as st from './ModalRecommendetion.module.scss';

const ModalRecommendetion = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const data = useAppSelector((state) => state.modals.recommendProps);

  const handleConfirm = () => {
    enableScroll();
    dispatch(closeRecommendModal());
    data.confirm && data.confirm();
  };

  return (
    <ModalSmall
      isOpen
      title={data.title}
      overlayClassName={st.overlay}
      // onRequestClose={handleConfirm}
    >
      <article className={st.wrapper}>
        <p className={st.text}>
          Специалист: <span> {data.specialist}</span>
        </p>
        <CoachAvatar className={st.image} photo={data.photo} />
        <p className={st.text}>
          {data.text} <span> &quot;{data.cardName}&quot;</span>
        </p>

        <CommonButton className={st.button} onClick={handleConfirm}>
          {data.confirmText}
        </CommonButton>
      </article>
    </ModalSmall>
  );
};

export default ModalRecommendetion;
